export default {
  async init(): Promise<undefined> {
    return;
  },

  areAttachmentsEnabled(): true {
    return true;
  },
};
